const planData = (() => {
    let planId;
    let ispData;
    let dropdowns;

    // CHARACTER LIMITS
    //-----------------------------------------
    const characterLimits = {
        assessment: {},
        isp: {
            consentAndSign: {
                dissentAreaDisagree: 2500,
                dissentHowToAddress: 2500,
            },
            contactInfo: {
                moreDetail: 10000,
            },
            restrictiveMeasures: {
                rmKeepSelfSafe: 2500,
                rmFadeRestriction: 10000,
                rmWhatCouldHappenGood: 2500,
                rmWhatCouldHappenBad: 2500,
                rmOtherWayHelpGood: 2500,
                rmOtherWayHelpBad: 2500,
            },
            introduction: {
                likeAdmire: 2464,
                thingsImportantTo: 2464,
                thingsImportantFor: 2464,
                howToSupport: 2464,
            },
            outcomes: {
                description: 2500,
                details: 2500,
                history: 2500,
                carryOverReason: 255,
                whatNeedsToHappen: 2500, // exp
                howItShouldHappen: 2500, // exp
                whenHowOften: 255, // exp
                whenHowOftenOther: 255, // exp
                whatWillHappen: 2500, // rev
                whenToCheckIn: 2500, // rev
            },
            servicesSupports: {
                scopeOfService: 10000, // paid supp
                fundingSourceOther: 2500, // paid supp
                howOftenHowMuch: 255, // paid supp
                howOftenOther: 2500, // paid supp
                whatSupportLooksLike: 2500, // add supp
                whenHowOften: 2500, // add supp
                whenHowOftenOther: 2500, // add supp
                reasonForReferral: 2500, // prof ref
                otherInfo: 10000,//add supp
            },
            summary: {
                aloneTime: 10000,
                importantTo: 10000,
                importantFor: 10000,
                skillsAndAbilities: 10000,
                whatIsRisk: 10000,
                whatSupportLooksLike: 10000,
            },
        },
    };
    function getISPCharacterLimits(section) {
        return characterLimits.isp[section];
    }
    function getAllISPcharacterLimts() {
        return characterLimits.isp;
    }
    function getAssessmentCharacterLimits(section) {
        return characterLimits.assessment[section];
    }

    // DROPDOWN DATA
    //-----------------------------------------
    const removeDupRelationships = relationships => {
        const unique = [];
        const flag = {};
        relationships.forEach(el => {
            if (!flag[el.peopleId]) {
                flag[el.peopleId] = true;
                el.lastName = el.lastName.split('|')[0];
                unique.push(el);
            }
        });
        return unique;
    };
    const removeDups = data => {
        const flag = {};
        const flagN = {};
        const unique = [];
        data.forEach(el => {
            if (!flag[el.value] && !flagN[el.text]) {
                flag[el.value] = true;
                flagN[el.text] = true;
                unique.push(el);
            }
        });
        return unique;
    };
    async function setDropdownData() {
        const defaultDropdowns = {
            fundingSource: [
                { value: '%', text: '' },
                { value: '1', text: 'HCBS Individual Options Waiver' },
                { value: '2', text: 'HCBS Level One Waiver' },
                { value: '3', text: 'HCBS SELF Waiver' },
                { value: '4', text: 'ICF' },
                { value: '5', text: 'State Plan Services' },
                { value: '6', text: 'Local Funds' },
                { value: '7', text: 'Local Funds--Contracted with Ohio Department of Aging' },
                { value: '8', text: 'Other' },
            ],
            serviceTypes: [],
            newOrExisting: [
                { value: '%', text: '' },
                { value: '1', text: 'Referral Needed' }, //
                { value: '2', text: 'Existing' },
            ],
            howOftenHowMuchFrequency: [
                { value: '%', text: '' },
                { value: '1', text: 'Daily' },
                { value: '2', text: 'Weekly' },
                { value: '3', text: 'Monthly' },
                { value: '4', text: 'Miles' },
                { value: '5', text: 'Other' },
            ],
            whenHowOftenFrequency: [
                { value: '%', text: '' },
                { value: '1', text: 'Daily' },
                { value: '2', text: 'Weekly' },
                { value: '3', text: 'Monthly' },
                { value: '4', text: 'Other' },
            ],
            howOFtenExperiences: [
                { value: '%', text: '' },
                { value: '1', text: 'Weekly' },
                { value: '2', text: 'Monthly' },
                { value: '3', text: 'Other' },
            ],
            communicationType: [
                // { value: '%', text: '' },
                { value: '1', text: 'Letter / Mail.' },
                { value: '2', text: 'Phone Call.' },
                { value: '3', text: 'Text.' },
                { value: '4', text: 'Email.' }, //
                { value: '5', text: 'Social Media.' },
                { value: '6', text: 'Video Meeting.' },
                { value: '7', text: 'Other.' },
            ],
            dailyLifeDropdownType: [
                { value: '%', text: '' },
                {
                    value: '1',
                    text: '1 Person has a job, may be interested in a different one or moving up.',
                },
                { value: '2', text: '2 Person wants a job and needs help to find one.' },
                {
                    value: '3',
                    text: `3 Person isn't sure about work and may need to learn more.`,
                },
                {
                    value: '4',
                    text: `4 Person doesn't think they want to work, but may not know enough about it.`,
                },
            ],
            levelsOfSupervision: [
                { value: '%', text: '' },
                { value: '1', text: 'No Paid Supports' },
                { value: '2', text: 'General' },
                { value: '3', text: 'Auditory' },
                { value: '4', text: 'Visual' },
                { value: '5', text: 'Close & Constant' },
                { value: '6', text: 'Technology' },
            ],
            outcomeStatus: [
                { value: '0', text: 'In Progress' },
                { value: '1', text: 'Complete' },
            ],
        };

        const retrieveData = {
            token: $.session.Token,
            effectiveStartDate: UTIL.getFormattedDateFromDate(planDates.getEffectiveStartDate(), {
                format: 'iso',
            }),
            effectiveEndDate: UTIL.getFormattedDateFromDate(planDates.getEffectiveEndDate(), {
                format: 'iso',
            }),
            consumerId: plan.getSelectedConsumer().id,
            areInSalesForce: $.session.areInSalesForce,
            planId,
        };

        const [dropdownDataResult, serviceTypesResult] = await Promise.all([
            planAjax
                .getPlanDropdownData(retrieveData)
                .then(value => ({ value }))
                .catch(error => ({ error })),
            planAjax
                .getPlanServiceTypes(retrieveData)
                .then(value => ({ value }))
                .catch(error => ({ error })),
        ]);

        if (dropdownDataResult.value) {
            dropdowns = {
                ...dropdownDataResult.value,
                ...defaultDropdowns,
            };

            dropdowns.relationshipsWithDups = dropdowns.relationships;
            dropdowns.relationships = removeDupRelationships(dropdowns.relationships);
        } else {
            dropdowns = {
                ...defaultDropdowns,
            };
        }

        if (!serviceTypesResult.error) {
            dropdowns.serviceTypes = serviceTypesResult.value;
        } else {
            console.log(serviceTypesResult.error);
        }
    }
    function getDropdownData() {
        return dropdowns;
    }

    async function getServiceTypeOtherInfo(serviceTypeId) {
        const otherInfoObj = await planAjax.getServiceTypeOtherInfo($.session.Token, serviceTypeId);
        if (!otherInfoObj || otherInfoObj.length == 0) return '';
        const otherInfo = JSON.parse(otherInfoObj.getServiceTypeOtherInfoResult);
        return otherInfo[0];
    }
    async function getServiceTypeNames() {
        const serviceTypes = await planAjax.getServiceTypeOtherInfo($.session.Token, 0);
        return JSON.parse(serviceTypes.getServiceTypeOtherInfoResult);
    }
    async function saveOrUpdateOtherInfo(data) {
        const result = await planAjax.saveOrUpdateOtherInfo(data);  
        if (result.saveOrUpdateOtherInfoResult.indexOf('error') >= 0) {
            return [{ insertId: 0 }];
        }
        return JSON.parse(result.saveOrUpdateOtherInfoResult);
    }
    async function refreshDropdownData() {
        await setDropdownData();
        planSummary.refreshDropdownData(dropdowns);
        planOutcomes.refreshDropdownData(dropdowns);
        servicesSupports.refreshDropdownData(dropdowns);
        contactInformation.refreshDropdownData(dropdowns);
    }
    function getRelationshipNameById(contactId) {
        if (!contactId) return '';

        if (contactId.endsWith('V')) {
            const supportData = servicesSupports.getSelectedVendors();
            const filteredService = supportData.filter(dd => `${dd.providerId}V` === contactId);
            if (filteredService.length > 0) {
                return `${filteredService[0].providerName}`;
            } else {
                return '';
            }
        } else {
            const filteredService = dropdowns.relationships.filter(dd => dd.contactId === contactId);
            if (filteredService.length > 0) {
                if (!filteredService[0].lastName || !filteredService[0].firstName) return '';
                return `${filteredService[0].lastName}, ${filteredService[0].firstName}`;
            } else {
                return '';
            }
        }
    }
    function populateRelationshipDropdown(dropdownEle, defaultValue, includeSupports = false) {
        //if ($.session.areInSalesForce) {
        // group populate
        const teamMemberGroup = {
            groupLabel: 'Plan Team Member',
            groupId: 'teamMemberGroup',
            dropdownValues: [],
        };
        const nonTeamMemberGroup = {
            groupLabel: 'Not a Team Member on this Plan',
            groupId: 'nonTeamMemberGroup',
            dropdownValues: [],
        };
        const paidSupportsGroup = {
            groupLabel: 'Providers on this Plan',
            groupId: 'paidSupportsGroup',
            dropdownValues: [],
        };

        dropdowns.relationships.forEach(dd => {
            if (dd.signatureId) {
                teamMemberGroup.dropdownValues.push({
                    value: dd.contactId,
                    text: `${dd.lastName}, ${dd.firstName}`,
                });
            } else {
                nonTeamMemberGroup.dropdownValues.push({
                    value: dd.contactId,
                    text: `${dd.lastName}, ${dd.firstName}`,
                });
            }
        });

        teamMemberGroup.dropdownValues = removeDups(teamMemberGroup.dropdownValues);
        nonTeamMemberGroup.dropdownValues = removeDups(nonTeamMemberGroup.dropdownValues);

        teamMemberGroup.dropdownValues.sort((a, b) => {
            const textA = a.text.toUpperCase();
            const textB = b.text.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        nonTeamMemberGroup.dropdownValues.sort((a, b) => {
            const textA = a.text.toUpperCase();
            const textB = b.text.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

        const groupDropdownData = [];
        groupDropdownData.push(teamMemberGroup);
        groupDropdownData.push(nonTeamMemberGroup);

        if (includeSupports) {
            const supportData = servicesSupports.getSelectedVendors();
            paidSupportsGroup.dropdownValues = supportData.map(ps => {
                return {
                    value: `${ps.providerId}V`,
                    text: ps.providerName,
                };
            });

            paidSupportsGroup.dropdownValues = removeDups(paidSupportsGroup.dropdownValues);
            paidSupportsGroup.dropdownValues.sort((a, b) => {
                const textA = a.text.toUpperCase();
                const textB = b.text.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            groupDropdownData.push(paidSupportsGroup);
        }

        dropdown.groupingPopulate({
            dropdown: dropdownEle,
            data: groupDropdownData,
            nonGroupedData: [{ value: '', text: '' }],
            defaultVal: defaultValue,
        });
        // } else {
        //   let data;
        //   // normal populate
        //   const data1 = dropdowns.relationships.map(dd => {
        //     return {
        //       value: dd.contactId,
        //       text: `${dd.lastName}, ${dd.firstName}`,
        //     };
        //   });

        //   if (includeSupports) {
        //     const supportData = servicesSupports.getSelectedVendors();
        //     const data2 = supportData.map(ps => {
        //       return {
        //         value: `${ps.providerId}V`,
        //         text: ps.providerName,
        //       };
        //     });

        //     data = [...data1, ...data2];
        //   } else {
        //     data = data1;
        //   }

        //   data.sort((a, b) => {
        //     const textA = a.text.toUpperCase();
        //     const textB = b.text.toUpperCase();
        //     return textA < textB ? -1 : textA > textB ? 1 : 0;
        //   });
        //   data.unshift({ value: '', text: '' });

        //   dropdown.populate(dropdownEle, removeDups(data), defaultValue);
        // }
    }

    async function populateOutcomesReviewWhoDropdown(dropdownEle, defaultValue) {
        //if ($.session.areInSalesForce) {
        // group populate
        const teamMemberGroup = {
            groupLabel: 'Plan Team Member',
            groupId: 'teamMemberGroup',
            dropdownValues: [],
        };
        const nonTeamMemberGroup = {
            groupLabel: 'Not a Team Member on this Plan',
            groupId: 'nonTeamMemberGroup',
            dropdownValues: [],
        };
        const paidSupportsGroup = {
            groupLabel: 'Providers on this Plan',
            groupId: 'paidSupportsGroup',
            dropdownValues: [],
        };
        const locationsGroup = {
            groupLabel: 'Facilities on this Plan ',
            groupId: 'locationsGroup',
            dropdownValues: [],
        };

        dropdowns.relationships.forEach(dd => {
            if (dd.signatureId) {
                teamMemberGroup.dropdownValues.push({
                    value: dd.contactId,
                    text: `${dd.lastName}, ${dd.firstName}`,
                });
            } else {
                nonTeamMemberGroup.dropdownValues.push({
                    value: dd.contactId,
                    text: `${dd.lastName}, ${dd.firstName}`,
                });
            }
        });

        teamMemberGroup.dropdownValues = removeDups(teamMemberGroup.dropdownValues);
        nonTeamMemberGroup.dropdownValues = removeDups(nonTeamMemberGroup.dropdownValues);

        teamMemberGroup.dropdownValues.sort((a, b) => {
            const textA = a.text.toUpperCase();
            const textB = b.text.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        nonTeamMemberGroup.dropdownValues.sort((a, b) => {
            const textA = a.text.toUpperCase();
            const textB = b.text.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

        const groupDropdownData = [];
        groupDropdownData.push(teamMemberGroup);
        groupDropdownData.push(nonTeamMemberGroup);

        const teamMemberData = await consentAndSignAjax.getConsentAndSignData({
            token: $.session.Token,
            assessmentId: planId,
        });

        // var theseVendors = teamMemberData.filter(vendor => vendor.vendorId !== '' && vendor.salesForceId !== '');
        var theseVendors = teamMemberData.filter(member => member.vendorId !== '');
        paidSupportsGroup.dropdownValues = theseVendors.map(ps => {
            return {
                value: `${ps.vendorId}V`,
                text: ps.name,
            };
        });

        paidSupportsGroup.dropdownValues = removeDups(paidSupportsGroup.dropdownValues);
        paidSupportsGroup.dropdownValues.sort((a, b) => {
            const textA = a.text.toUpperCase();
            const textB = b.text.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        if (theseVendors.length > 0) groupDropdownData.push(paidSupportsGroup);

        if ($.session.applicationName !== 'Gatekeeper') {
            var theseLocations = teamMemberData.filter(member => member.locationId !== '');
            //var theseLocations = teamMemberData.filter(member => member.locationId !== '');
            locationsGroup.dropdownValues = theseLocations.map(ps => {
                return {
                    value: `${ps.locationId}L`,
                    text: ps.name,
                };
            });

            locationsGroup.dropdownValues = removeDups(locationsGroup.dropdownValues);
            locationsGroup.dropdownValues.sort((a, b) => {
                const textA = a.text.toUpperCase();
                const textB = b.text.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            if (theseLocations.length > 0) groupDropdownData.push(locationsGroup);
        }

        // If defaultValue is text instead of value, find the corresponding value
        let finalDefaultValue = defaultValue;

        if (defaultValue && defaultValue !== '') {
            // Search through all groups to find matching text and get the corresponding value
            for (const group of groupDropdownData) {
                const matchingItem = group.dropdownValues.find(item =>
                    item.text.trim() === defaultValue.trim()
                );
                if (matchingItem) {
                    finalDefaultValue = matchingItem.value;
                    break;
                }
            }
        }

        dropdown.groupingPopulate({
            dropdown: dropdownEle,
            data: groupDropdownData,
            nonGroupedData: [{ value: '', text: '' }],
            defaultVal: finalDefaultValue,
        });
    }

    async function init(planID, planVersionNumber) {
        planId = planID;
        await setDropdownData();
        //$.session.planVersionNumber = planVersionNumber;
        // await planValidation.init(planId, planVersionNumber);//
    }

    return {
        init,
        getDropdownData,
        getRelationshipNameById,
        getISPCharacterLimits,
        getAllISPcharacterLimts,
        getAssessmentCharacterLimits,
        populateRelationshipDropdown,
        populateOutcomesReviewWhoDropdown,
        refreshDropdownData,
        getServiceTypeOtherInfo,
        getServiceTypeNames,
        saveOrUpdateOtherInfo
    };
})();
